import { DenormalizedTask, TaskTypeToSelect } from '@shared/models';

export const collectionDefaultValues = {
  tasks: [] as DenormalizedTask[],
  taskModalType: null as TaskTypeToSelect | null,
};
